module.exports = __webpack_public_path__ + "img/14.3d88cc46.png";